module.exports = __webpack_public_path__ + "static/media/total-reveues-icon.b58bcb3b.svg";